import { ref, reactive, computed, watch } from 'vue';
import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/message/style/css';
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/leftSlide/haveChoose.png';
import _imports_1 from '@/assets/images/leftSlide/noChoose.png';
const _withScopeId = n => (_pushScopeId("data-v-0db5f323"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "editHelpWrapper flex-1"
};
const _hoisted_2 = {
  class: "header cursor-p"
};
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "allrolebox"
};
const _hoisted_5 = {
  class: "allRoleForChoose row j-sb"
};
const _hoisted_6 = ["onClick", "src"];
const _hoisted_7 = ["onClick"];
const _hoisted_8 = {
  key: 0,
  class: "all100",
  src: _imports_0,
  alt: ""
};
const _hoisted_9 = {
  key: 1,
  class: "all100",
  src: _imports_1,
  alt: ""
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "inner",
  style: {
    "height": "0px",
    "border": "0"
  }
}, null, -1));
const _hoisted_11 = {
  key: 1
};
const _hoisted_12 = {
  key: 0,
  class: "from_container"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label"
}, [/*#__PURE__*/_createElementVNode("span", null, "*"), /*#__PURE__*/_createTextVNode(" 名字 ")], -1));
const _hoisted_14 = {
  class: "limit"
};
const _hoisted_15 = {
  style: {
    "color": "#006eff"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label"
}, [/*#__PURE__*/_createElementVNode("span", null, "*"), /*#__PURE__*/_createTextVNode(" 职业技能 ")], -1));
const _hoisted_17 = {
  class: "limit"
};
const _hoisted_18 = {
  style: {
    "color": "#006eff"
  }
};
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label"
}, [/*#__PURE__*/_createElementVNode("span", null, "*"), /*#__PURE__*/_createTextVNode(" 角色形象 ")], -1));
const _hoisted_20 = {
  class: "roleImg"
};
const _hoisted_21 = ["src"];
const _hoisted_22 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("label", null, null, -1));
const _hoisted_23 = [_hoisted_22];
const _hoisted_24 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "label",
  style: {
    "margin-top": "17px"
  }
}, "角色描述", -1));
const _hoisted_25 = {
  class: "btn_list"
};
import { useStore } from 'vuex';
import confirmHint from '@/components/confirm/index.vue';
import { saveRole, queryAvatar, queryRole, updateRole, deleteRole } from '@/api/role';
export default /*#__PURE__*/_defineComponent({
  __name: 'editHelp',
  props: ['isEditOrAdd', 'select_role_ac'],
  emits: ['close', 'back'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const store = useStore();
    const showSelectRole = ref(false);
    const chooseAc = ref(0);
    let tempData = reactive({
      name: '',
      professionalSkill: '',
      synopsis: '',
      digitalManImg: 'https://mobvoi-digitalhuman-public.cn-bj.ufileos.com/metaman/storage_audio/DEFAULT_GROUP/20230113/8225854a08124ace8349b2c355a67184.b58488b3e40948978c50e8ac3cbbe84d.luara_head.png',
      digitalManId: '1644252501031129098',
      speakerId: 'Ziyan_female_400'
    });
    const formLabelAlign = computed(() => {
      if (props.isEditOrAdd == 'add') {
        return tempData;
      } else {
        return store.state.role.onwerAllRoleList[props.select_role_ac];
      }
    });
    watch(() => formLabelAlign.value.synopsis, (n, o) => {
      if (n.length > 200) {
        formLabelAlign.value.synopsis = formLabelAlign.value.synopsis.slice(0, 200);
      }
    }, {
      immediate: true
    });
    const save_chooseRole = () => {
      showSelectRole.value = false;
      let o = allRoleArr.value[chooseAc.value];
      formLabelAlign.value.digitalManId = o.id;
      formLabelAlign.value.speakerId = o.speakerId;
      formLabelAlign.value.digitalManImg = o.headUrl;
    };
    // 点击保存作区分
    // 删除role部分
    const showHint = ref(false);
    const btnClick = status => {
      if (!status) {
        showHint.value = status;
      } else {
        delteRoleClick();
      }
    };
    const limitClick = ref(true);
    const delteRoleClick = async () => {
      const res = await deleteRole({
        id: formLabelAlign.value.id
      });
      if (res.code == 200) {
        showHint.value = false;
        ElMessage.success({
          message: '删除角色成功'
        });
        searchAllRoles();
        emits('back', false);
      } else {
        showHint.value = false;
        ElMessage.error({
          message: '删除角色失败'
        });
      }
    };
    const formRef = ref();
    let isSaveing = ref(false);
    const saveRoleClick = formEl => {
      if (!limitClick.value) {
        return;
      }
      limitClick.value = false;
      setTimeout(() => {
        limitClick.value = true;
      }, 2000);
      if (!formEl) return;
      formEl.validate(valid => {
        if (valid) {
          if (isSaveing.value) return;
          isSaveing.value = true;
          if (!formLabelAlign.value.name.trim() || !formLabelAlign.value.professionalSkill.trim()) {
            ElMessage.warning({
              message: '请完善信息后提交'
            });
            return;
          }
          if (props.isEditOrAdd == 'add') {
            addRolePort();
          } else {
            editRolePort();
          }
        } else {}
      });
    };
    // 查询接口
    const searchAllRoles = async () => {
      const queryRes = await queryRole({});
      if (queryRes.code == 200) {
        store.commit('role/setonwerAllRoleList', queryRes.data);
      }
    };
    // 编辑接口
    const editRolePort = async () => {
      const res = await updateRole(formLabelAlign.value);
      if (res.code == 200) {
        ElMessage.success({
          message: '更新角色成功'
        });
        searchAllRoles();
        emits('back', false);
      } else {
        ElMessage.error({
          message: '更新角色失败'
        });
      }
      isSaveing.value = false;
    };
    // 添加role接口
    const addRolePort = async () => {
      const res = await saveRole(formLabelAlign.value);
      if (res.code == 200) {
        ElMessage.success({
          message: '保存角色成功'
        });
        searchAllRoles();
        emits('back', false);
      } else {
        ElMessage.error({
          message: '保存角色失败'
        });
      }
      isSaveing.value = false;
    };
    let allRoleArr = ref([]);
    const chooseRoleClick = async () => {
      showSelectRole.value = true;
      const res = await queryAvatar({
        page: 1,
        limit: 10000
        // customType: 'sys',
        // product: 'copilot',
        // wwid: store.state.userInfo.userInfo.unionNo
      });

      if (res.code == 200) {
        allRoleArr.value = res.data.records;
        allRoleArr.value.forEach((role, index) => {
          if (role.id === formLabelAlign.value.digitalManId) {
            chooseAc.value = index;
          }
        });
      }
      console.log(res);
    };
    const settingData = reactive({
      selectList: [{
        imgUrl: require('@/assets/images/leftSlide/avatar.png')
      }],
      triangleType: 'top',
      style: {
        left: '125px',
        top: '-16px'
      }
    });
    const selectedData = computed(() => store.state.role.chooseRole.headUrl);
    const rules = reactive({
      name: [{
        required: true,
        message: '请填写名字',
        trigger: 'blur'
      }, {
        min: 0,
        max: 10,
        message: '长度不能超过7个字符',
        trigger: 'blur'
      }],
      professionalSkill: [{
        required: true,
        message: '请填写职业技能',
        trigger: 'blur'
      }, {
        min: 0,
        max: 20,
        message: '长度不能超过15个字符',
        trigger: 'blur'
      }]
      // synopsis: [
      //   { required: true, message: '请填写描述信息', trigger: 'blur' },
      //   { min: 0, max: 200, message: '长度不能超过200个字符', trigger: 'blur' }
      // ]
    });

    const nameInputNum = computed(() => formLabelAlign.value.name.length);
    const nameSkillNum = computed(() => formLabelAlign.value.professionalSkill.length);
    const close = () => {
      emits('close', false);
    };
    const goBack = () => {
      emits('back', false);
    };
    return (_ctx, _cache) => {
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_form = _resolveComponent("el-form");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_unref(showSelectRole) ? (_openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("label", {
        onClick: _cache[0] || (_cache[0] = $event => showSelectRole.value = false),
        class: "backIcon"
      }), _createElementVNode("span", {
        onClick: _cache[1] || (_cache[1] = $event => showSelectRole.value = false)
      }, "选择角色形象"), _createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(allRoleArr), (item, index) => {
        return _openBlock(), _createElementBlock("span", {
          class: _normalizeClass(["inner", {
            current: _unref(chooseAc) == index
          }]),
          key: index
        }, [_createElementVNode("img", {
          class: "all100",
          onClick: $event => chooseAc.value = index,
          src: item.headUrl,
          alt: "icon"
        }, null, 8, _hoisted_6), _createElementVNode("div", {
          class: "selectBox",
          onClick: $event => chooseAc.value = index
        }, [_unref(chooseAc) == index ? (_openBlock(), _createElementBlock("img", _hoisted_8)) : (_openBlock(), _createElementBlock("img", _hoisted_9))], 8, _hoisted_7)], 2);
      }), 128)), _hoisted_10])]), _createElementVNode("div", {
        class: "btn_list"
      }, [_createElementVNode("div", {
        class: "saveBtn common cursor-p text-center m-auto",
        onClick: save_chooseRole
      }, " 保存 ")])])) : (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("label", {
        onClick: goBack,
        class: "backIcon"
      }), _createElementVNode("span", {
        onClick: goBack
      }, _toDisplayString(__props.isEditOrAdd === 'add' ? '添加AI助手' : '编辑AI助手'), 1)]))]), !_unref(showSelectRole) ? (_openBlock(), _createElementBlock("div", _hoisted_12, [_createVNode(_component_el_form, {
        ref_key: "formRef",
        ref: formRef,
        rules: _unref(rules),
        model: _unref(formLabelAlign),
        style: {
          "max-width": "100%",
          "padding-bottom": "144px"
        }
      }, {
        default: _withCtx(() => [_hoisted_13, _createVNode(_component_el_form_item, {
          prop: "name"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            maxlength: 10,
            placeholder: "请输入名字",
            modelValue: _unref(formLabelAlign).name,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => _unref(formLabelAlign).name = $event),
            modelModifiers: {
              trim: true
            }
          }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_14, [_createElementVNode("span", _hoisted_15, _toDisplayString(_unref(nameInputNum)), 1), _createTextVNode("/10")])]),
          _: 1
        }), _hoisted_16, _createVNode(_component_el_form_item, {
          prop: "professionalSkill"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            maxlength: 20,
            placeholder: "请填写职业技能",
            modelValue: _unref(formLabelAlign).professionalSkill,
            "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => _unref(formLabelAlign).professionalSkill = $event),
            modelModifiers: {
              trim: true
            }
          }, null, 8, ["modelValue"]), _createElementVNode("span", _hoisted_17, [_createElementVNode("span", _hoisted_18, _toDisplayString(_unref(nameSkillNum)), 1), _createTextVNode("/20")])]),
          _: 1
        }), _hoisted_19, _createElementVNode("div", {
          class: "inputRole cursor-p",
          onClick: chooseRoleClick
        }, [_createElementVNode("div", _hoisted_20, [_createElementVNode("img", {
          class: "all100",
          src: _unref(formLabelAlign).digitalManImg,
          alt: "icon"
        }, null, 8, _hoisted_21)]), _createElementVNode("div", {
          class: "arrowRight cursor-p",
          onClick: chooseRoleClick
        }, _hoisted_23)]), _hoisted_24, _createVNode(_component_el_form_item, {
          prop: "synopsis"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_input, {
            modelValue: _unref(formLabelAlign).synopsis,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => _unref(formLabelAlign).synopsis = $event),
            rows: 10,
            type: "textarea",
            resize: "none",
            placeholder: "请填写描述信息",
            maxlength: 200,
            "show-word-limit": ""
          }, null, 8, ["modelValue"])]),
          _: 1
        })]),
        _: 1
      }, 8, ["rules", "model"]), _createElementVNode("div", _hoisted_25, [_createElementVNode("div", {
        onClick: _cache[5] || (_cache[5] = $event => saveRoleClick(_unref(formRef))),
        class: _normalizeClass(["saveBtn common cursor-p text-center m-auto", {
          disableclick: _unref(isSaveing)
        }])
      }, _toDisplayString(_unref(isSaveing) ? '保存中...' : '保存'), 3), _withDirectives(_createElementVNode("div", {
        onClick: _cache[6] || (_cache[6] = $event => showHint.value = true),
        class: "delteBtn common cursor-p text-center m-auto"
      }, " 删除 ", 512), [[_vShow, _unref(formLabelAlign).roleType == 2]])])])) : _createCommentVNode("", true), _withDirectives(_createVNode(confirmHint, {
        onBtnClick: btnClick
      }, null, 512), [[_vShow, _unref(showHint)]])]);
    };
  }
});